import { Control } from '@yleisradio/areena-types';
import React from 'react';
import { AlternateButton } from '..';
import Icon from 'assets/chevronLeft.svg';

interface BackLinkProps {
  control: Control;
  disabled?: boolean;
  onClick?: React.MouseEventHandler | undefined;
  dataTestId?: string | undefined;
}

export const BackLink: React.FunctionComponent<BackLinkProps> = ({
  control,
  disabled = false,
  onClick,
  dataTestId,
}) => {
  return control.title ? (
    <AlternateButton
      pointer={control.destination}
      text={control.title}
      isDisabled={disabled}
      Icon={Icon}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  ) : null;
};
